/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { NavLink } from 'react-router-dom';
import Select from 'react-select';
import Loading from '../../common/Loading';

import './index.scss';

Modal.setAppElement('#root');

const selectCampaignType = [
  {
    label: 'Appointment',
    value: 'SESSION',
  },
  {
    label: 'Class',
    value: 'CLASS',
  }
];

class CreateLeadEngageLayover extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      name: '',
    };
  }

  closeModal() {
    this.props.closeCampaignModel();
  }

  addCampaign = () => {
    this.props.saveLeadName(this.state.name);
    this.props.closeCampaignModel();
    this.props.history.push('/app/addleadengage');
  };

  handleChange = (event) => {
    this.setState({
      name: event.target.value,
    });
  };

  render() {
    const { modelopen, auth, isLoading } = this.props;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="modal-header">
              <div className="title">Add New Campaign</div>
              <button className="modal-close" onClick={this.closeModal}>
                X
              </button>
              {isLoading?
              (<div className="add-campaign_loader">
                  <Loading />
                </div>):(<>

              <div className="input">
                <label className="label">Campaign Name</label>
                <input
                  type="text"
                  value={this.state.name}
                  onChange={this.handleChange}
                  maxlength="100"
                />
              </div>
              {auth.domain == 'FITNESS' &&
                (<div className="input">
                  <label className="label">Campaign Type</label>
                  <Select
                     value={selectCampaignType.filter(c => c.value === this.props.campaign_type)}
                     getOptionLabel={(option) => option.label}
                     getOptionValue={(option) => option.value}
                     options={selectCampaignType}
                     onChange={this.props.onCampaignTypeChange}
                  />
                </div>)
              }
              <div className="actions">
                <button
                  className="btn btn--primary btn--lg"
                  onClick={this.addCampaign}
                  disabled={this.state.name.trim().length < 1}
                >
                  NEXT
                </button>
                <button
                  className="btn btn--secondary btn--lg"
                  onClick={this.closeModal}
                >
                  CANCEL
                </button>
              </div>
            
            </>)}
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default CreateLeadEngageLayover;
